import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";

import * as moment from "moment";
import { environment } from "src/environments/environment";
declare let window: any;

// Add this type near the top of the file after imports
type SubcategoryKey = "Spot" | "Usage" | "SavingsPlanCoveredUsage";

@Component({
  selector: "ec2-billing",
  templateUrl: "ec2.billing.component.html",
  styleUrls: ["./../../billing.component.css", "./ec2.billing.component.css"],
})
export class EC2BillingComponent implements OnInit, OnDestroy, OnChanges {
  @Input("activeAccount") activeAccount: any;
  @Input("monthYear") monthYear: any;
  @Input("response") response: any;
  @Input("serviceData") serviceData: any;
  @Input("finalEc2") finalEc2: any;
  @Input("diff_days") diff_days: any;
  selectedReport: boolean = false;
  userId = localStorage.getItem("eId");
  ut = localStorage.getItem("ut");
  urlPrefix: any = localStorage.getItem("role") == "Admin" ? "admin" : "client";
  customerType: string = localStorage.getItem("customerType");
  writeAccess: boolean =
    localStorage.getItem("acT") == "readandwrite" ||
    this.urlPrefix == "admin" ||
    localStorage.getItem("ut") == "admin";
  loading = true;

  expanded: Record<SubcategoryKey, boolean> = {
    Spot: false,
    Usage: false,
    SavingsPlanCoveredUsage: false,
  };

  ec2Data: any = [];
  ec2Show: boolean = false;
  projectTagNameEC2: boolean = false;
  mapMigratedEC2: boolean = false;
  projectTagNameEBS: boolean = false;
  mapMigratedEBS: boolean = false;
  ec2Headers: any = [
    {
      id: "lid_instanceId",
      name: "Instance ID",
      export: true,
    },
    {
      id: "instance_name",
      name: "Tag Name",
      export: true,
    },
    {
      id: "projectTagName",
      name: "Project Tag Name",
      export: true,
      displayConditional: true,
    },
    {
      id: "mapMigrated",
      name: "Map Migrated Tag Name",
      export: true,
      displayConditional: true,
    },
    {
      id: "admin_instance_type",
      name: "Instance Type",
      export: true,
    },
    {
      id: "cpu",
      name: "CPU",
      export: true,
    },
    {
      id: "ram",
      name: "Ram",
      export: true,
    },
    {
      id: "os",
      name: "OS",
      export: true,
    },
    {
      id: "region",
      name: "Region",
      export: true,
    },
    {
      id: "RI",
      name: "RI Applied",
      export: true,
    },
    {
      id: "billingType",
      name: "Billing Type",
      export: true,
      alter: (value: any, param: any) => {
        let billingType: string = "";
        if (value[param].toLowerCase() == "dis-ri") {
          billingType = "OD-Discount";
        } else if (value[param].toLowerCase() == "m-ri") {
          billingType = "M-Reserved";
        } else if (value[param].toLowerCase() == "customer ri") {
          billingType = "Cust-Reserved";
        } else {
          billingType = value[param];
        }
        return billingType;
      },
    },
    {
      id: "hourly_cost",
      name: "AWS Cost/Hr",
      export: false,
      alter: (value: any, param: string) => {
        if (
          value[param] == "null" ||
          value["billingType"].toLowerCase() == "dis-ri"
        ) {
          return "-";
        }
        if (value["RI"] && value["RI"].toLowerCase() == "yes") {
          if (value["billingType"].toLowerCase() != "unusedcustomerri") {
            if (
              value["billingType"].toLowerCase() == "customer ri(unused ri)"
            ) {
              return `<span>${Number(value["riHourlyCost"]).toFixed(4)}</span>`;
            } else {
              return `<span class='line_through'>${Number(value[param]).toFixed(
                4
              )}</span> <span>${Number(value["riHourlyCost"]).toFixed(
                4
              )}</span>`;
            }
          } else {
            return Number(value["riHourlyCost"].toFixed(4));
          }
        } else {
          return Number(value[param]).toFixed(4);
        }
      },
    },
    {
      id: "hourly_cost",
      name: "AWS Cost/Hr",
      export: true,
      hide: true,
      alter: (value: any, param: string) => {
        if (
          value[param] == "null" ||
          value["billingType"].toLowerCase() == "dis-ri"
        ) {
          return "-";
        }
        if (value["RI"] && value["RI"].toLowerCase() == "yes") {
          if (value["billingType"].toLowerCase() != "unusedcustomerri") {
            return `<span>${Number(value[param]).toFixed(4)}</span>`;
          } else {
            return Number(value["riHourlyCost"]).toFixed(4);
          }
        } else {
          return Number(value[param]).toFixed(4);
        }
      },
    },
    {
      id: "total_hours",
      name: "AWS Total Hours",
      export: true,
      alter: (value: any, param: string) => {
        return isNaN(value[param]) ? "-" : Number(value[param]).toFixed(2);
      },
    },
    {
      id: "total_cost",
      name: "AWS Total OD COST",
      export: false,
      alter: (value: any, param: string) => {
        if (isNaN(value[param])) {
          return "-";
        } else if (
          this.response["savingsPlanCoveredUsage"] != 0 &&
          value["breakUpType"] == "SavingsPlanCoveredUsage" &&
          value["riTotalCost"] != undefined
        ) {
          if (Number(value["total_cost"]) === Number(value["riTotalCost"])) {
            return Number(value["riTotalCost"]).toFixed(4);
          } else {
            return `<span class='line_through'>${Number(
              value["total_cost"]
            ).toFixed(4)}</span> <span>${Number(value["riTotalCost"]).toFixed(
              4
            )}</span>`;
          }
        } else if (value["RI"] && value["RI"].toLowerCase() == "yes") {
          if (value["billingType"].toLowerCase() != "unusedcustomerri") {
            if (
              value["billingType"].toLowerCase() == "customer ri(unused ri)"
            ) {
              return `<span>${Number(value["riTotalCost"]).toFixed(4)}</span>`;
            } else {
              return `<span class='line_through'>${Number(value[param]).toFixed(
                4
              )}</span> <span>${Number(value["riTotalCost"]).toFixed(
                4
              )}</span>`;
            }
          } else {
            return Number(value["riTotalCost"].toFixed(4));
          }
        } else {
          return Number(value[param]).toFixed(4);
        }
      },
    },
    {
      id: "total_cost",
      name: "AWS Total Cost",
      hide: true,
      export: true,
      alter: (value: any, param: string) => {
        if (
          this.response["savingsPlanCoveredUsage"] != 0 &&
          value["breakUpType"] == "SavingsPlanCoveredUsage"
        ) {
          return Number(value["riTotalCost"]).toFixed(4);
        }
        return isNaN(value[param]) ? "-" : Number(value[param]).toFixed(4);
      },
    },
    {
      id: "riHourlyCost",
      name: "RI Rate",
      export: true,
      hide: true,
      alter: (value: any, param: string) => {
        return isNaN(value[param]) ? "-" : Number(value[param]).toFixed(4);
      },
    },
    {
      id: "riTotalCost",
      name: "Final Total Cost",
      hide: true,
      export: true,
      alter: (value: any, param: string) => {
        return value["RI"] && value["RI"].toLowerCase() == "yes"
          ? value["billingType"].toLowerCase() == "unusedcustomerri"
            ? `${Number(value["total_cost"]).toFixed(4)}`
            : Number(value[param]).toFixed(4)
          : Number(value["total_cost"]).toFixed(4);
      },
    },
    {
      id: "isMrr",
      name: "MRR Applied",
      export: true,
    },
    {
      id: "mrrCost",
      name: "AWS Total Cost",
      export: false,
      alter: (value: any, param: string) => {
        if (
          this.response["savingsPlanCoveredUsage"] != 0 &&
          value["breakUpType"] == "SavingsPlanCoveredUsage"
        ) {
          if (Number(value["riTotalCost"]) === Number(value["mrrCost"])) {
            return Number(value["mrrCost"]).toFixed(4);
          } else {
            return `<span class='line_through'>${Number(
              value["riTotalCost"]
            ).toFixed(4)}</span> <span>${Number(value["mrrCost"]).toFixed(
              4
            )}</span>`;
          }
        }
        if (value["RI"] && value["RI"].toLowerCase() == "yes") {
          if (Number(value["riTotalCost"]) !== Number(value["mrrCost"])) {
            return `<span class='line_through'>${Number(
              value["riTotalCost"]
            ).toFixed(4)}</span> <span>${Number(value["mrrCost"]).toFixed(
              4
            )}</span>`;
          } else {
            return Number(value["mrrCost"]).toFixed(4);
          }
        } else {
          if (Number(value["total_cost"]) !== Number(value["mrrCost"])) {
            return `<span class='line_through'>${Number(
              value["total_cost"]
            ).toFixed(4)}</span> <span>${Number(value["mrrCost"]).toFixed(
              4
            )}</span>`;
          } else {
            return Number(value["mrrCost"]).toFixed(4);
          }
        }
      },
    },
    {
      id: "mrrCost",
      name: "AWS Total Cost",
      export: true,
      hide: true,
      alter: (value: any, param: string) => {
        return Number(value["mrrCost"]).toFixed(4);
        // if (value["RI"] && value["RI"].toLowerCase() == "yes") {
        //   if (Number(value["riTotalCost"]) !== Number(value["mrrCost"])) {
        // return Number(value["mrrCost"]).toFixed(4);
        //   } else {
        //     return Number(value["mrrCost"]).toFixed(4);
        //   }
        // } else {
        //   if (Number(value["total_cost"]) !== Number(value["mrrCost"])) {
        //     return Number(value["mrrCost"]).toFixed(4);
        //   } else {
        //     return Number(value["mrrCost"]).toFixed(4);
        //   }
        // }
      },
    },
  ];

  ebsData: any = [];
  ebsShow: boolean = false;
  IOPSshow: boolean = true;
  operationsChange: boolean = true;
  ebsHeaders: any = [
    {
      id: "lid_volumeId",
      name: "Volume ID",
      filter: true,
      export: true,
    },
    {
      id: "volumeOperation",
      name: "Operation",
      export: true,
      show: () => this.operationsChange,
    },
    {
      id: "volume_name",
      name: "Tag Name",
      filter: true,
      export: true,
    },
    {
      id: "projectTagNameEBS",
      name: "Project Tag Name",
      export: true,
      displayConditional: true,
    },
    {
      id: "mapMigratedEBS",
      name: "Map Migrated Tag Name",
      export: true,
      displayConditional: true,
    },
    {
      id: "volume_type",
      name: "Volume Type",
      export: true,
      filter: true,
    },
    {
      id: "gb_cost",
      name: "GB Cost",
      export: true,
      alter: (value: any, param?: any) => {
        return isNaN(value) ? "0" : Number(value).toFixed(4);
      },
    },
    {
      id: "total_storage",
      name: "Total Storage (GB)",
      export: true,
      alter: (value: any, param?: any) => {
        if (
          param["operation"] != undefined &&
          param["operation"] !== "-" &&
          param["operation"].toLowerCase().indexOf("createvolume") < 0
        ) {
          return "-";
        }
        return isNaN(value) ? "0" : Number(value).toFixed(4);
      },
    },
    {
      id: "total_storage",
      name: "Read/Write (IOPS)",
      export: true,
      show: () => this.IOPSshow,
      alter: (value: any, param?: any) => {
        if (
          param["operation"] != undefined &&
          param["operation"] !== "-" &&
          param["operation"].toLowerCase().indexOf("io") < 0
        ) {
          return "-";
        }
        return isNaN(value) ? "0" : Number(value).toFixed(4);
      },
    },
    {
      id: "isMrr",
      name: "MRR Applied",
      export: true,
    },
    {
      id: "mrrCost",
      name: "Total Cost",
      export: true,
      alter: (value: any, param?: any) => {
        if (param["mrrCost"] == undefined) {
          return Number(param["total_cost"]).toFixed(4);
        }
        if (param["isMrr"] == "yes") {
          if (Number(param["total_cost"]) !== Number(param["mrrCost"])) {
            return `<span class='line_through'>${Number(
              param["total_cost"]
            ).toFixed(4)}</span> <span>${Number(param["mrrCost"]).toFixed(
              4
            )}</span>`;
          } else {
            return Number(param["total_cost"]).toFixed(4);
          }
        } else {
          return Number(param["total_cost"]).toFixed(4);
        }
      },
    },
  ];

  othersData: any = [];
  othersShow: boolean = false;
  othersHeaders: any = [
    {
      id: "lid_resourceId",
      name: "Resource ID",
      export: true,
    },
    {
      id: "resource_name",
      name: "Resource Name",
      export: true,
    },
    {
      id: "total_Gb_or_Cost",
      name: "Total GB",
      export: true,
      alter: (value: any, param: any) => {
        return Number(value).toFixed(2);
      },
    },
    {
      id: "isMrr",
      name: "MRR Applied",
      export: true,
    },
    {
      id: "mrrCost",
      name: "Total GB Cost",
      export: true,
      alter: (value: any, param?: any) => {
        if (param["mrrCost"] == undefined) {
          return Number(param["total_cost"]).toFixed(4);
        }
        if (param["isMrr"] == "yes") {
          if (Number(param["total_cost"]) !== Number(param["mrrCost"])) {
            return `<span class='line_through'>${Number(
              param["total_cost"]
            ).toFixed(4)}</span> <span>${Number(param["mrrCost"]).toFixed(
              4
            )}</span>`;
          } else {
            return Number(param["total_cost"]).toFixed(4);
          }
        } else {
          return Number(param["total_cost"]).toFixed(4);
        }
      },
    },
  ];

  accountId: any;
  regionId: any;
  currentMessage: any;
  page_destroyed: boolean = false;

  showConditionalElement = false;

  readonly PAGE_SIZE = 50;
  visibleData: Record<SubcategoryKey, any[]> = {
    Spot: [],
    Usage: [],
    SavingsPlanCoveredUsage: [],
  };

  constructor(
    private apiServer: APIService,
    public notifier: NotifierService,
    private zone: NgZone
  ) {}

  async ngOnChanges(changes: SimpleChanges) {
    this.customerType = localStorage.getItem("customerType");
    if (changes.activeAccount) {
      if (this.customerType == "mp") {
        await this.checkForExistingClient();
      }

      let finalEc2Cost = Math.min(
        Number(this.serviceData["ec2"]["discountedCost"]),
        Number(this.serviceData["ec2"]["service-cost"])
      );

      let totalEc2Cost = Math.max(
        Number(this.serviceData["ec2"]["discountedCost"]),
        Number(this.serviceData["ec2"]["service-cost"])
      );

      if (this.serviceData["ec2"]["discountedCost"] == null) {
        finalEc2Cost = Number(this.serviceData["ec2"]["service-cost"]);
        totalEc2Cost = Number(this.serviceData["ec2"]["service-cost"]);
      }

      this.response["finalEC2"] =
        finalEc2Cost -
        this.response["ebsMrrTotalCost"] -
        this.response["othersMrrTotalCost"];

      this.response["totalEC2"] =
        totalEc2Cost -
        Number(this.response["ebsTotalCost"]) -
        Number(this.response["othersTotalCost"]);

      if (this.response["finalEC2"] < 0) {
        this.response["finalEC2"] = 0;
      }

      if (this.response["finalEC2"] != this.response["totalEC2"]) {
        this.response[
          "finalEC2HTML"
        ] = `$<span class='line_through'>${this.response["totalEC2"].toFixed(
          2
        )}</span> $${this.response["finalEC2"].toFixed(2)}`;
      } else {
        this.response["finalEC2HTML"] = `$${this.response["finalEC2"].toFixed(
          2
        )}`;
      }

      // this.response["totalEC2"] = (
      //   (function() {
      //     this.response['services']
      //   }()) -
      //   Number(this.response["ebsMrrTotalCost"]) -
      //   Number(this.response["othersMrrTotalCost"])
      // ).toFixed(2);
      this.nextTokens = {
        ec2: null,
        ebs: null,
        others: null,
      };
      this.ec2Data = [];
      this.ebsData = [];
      this.othersData = [];
      if (this.ec2Show) {
        this.loadEC2Data(true);
      }
      if (this.ebsShow) {
        this.loadEBSData(true);
      }
      if (this.othersShow) {
        this.loadOthersData(true);
      }
    }
  }

  async ngOnInit() {
    // if (!this.monthYear || !this.activeAccount) {
    //   this.notifier.alert("Info", "", "Failed to Load Data", "info", 5000);
    // }
  }

  getCurrentMonth() {
    let monthYear: any = moment().startOf("month").format("MM-YYYY");

    let dRange = $("#datetimepicker").val();
    if (dRange) {
      monthYear = dRange;
    }

    return $("#datetimepicker").val();
  }

  async checkForExistingClient() {
    let data: any = { a: "validate", accountId: this.activeAccount.lid };

    let header: any = {
      Authorization: localStorage.getItem("t"),
    };

    let apiURL: string = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/billinguser`;

    let result: any = await this.apiServer.postDataPromis(apiURL, data, header);

    if (result.status == "1" || result.s == "1") {
      if (result.existingCustomer) {
        this.customerType = "C";
      } else {
        this.customerType = "mp";
      }
    }
  }

  nextTokens: any = {
    ec2: null,
    ebs: null,
    others: null,
  };

  getValue(value: string) {
    if (value == "projectTagName") {
      return this.projectTagNameEC2;
    }
    if (value == "mapMigrated") {
      return this.mapMigratedEC2;
    }
    if (value == "projectTagNameEBS") {
      return this.projectTagNameEBS;
    }
    if (value == "mapMigratedEBS") {
      return this.mapMigratedEBS;
    }
    return false;
  }

  filterHeaders(header: any) {
    return header.filter((head: any) => {
      return !head.hide;
    }).length;
  }

  getTotalOthers(data: any) {
    let total: number = 0;
    data.forEach((element: any) => {
      total += Number(element["total_cost"]);
    });

    return Number(total).toFixed(4);
  }

  getTotalEBS(data: any) {
    let total: any = {
      total: 0,
      gb_cost: 0,
      storage: 0,
      iops: 0,
    };
    data.forEach((element: any) => {
      total["total"] += Number(element["total_cost"]);
      total["gb_cost"] += Number(element["gb_cost"]);
      if (
        element["operation"] &&
        element["operation"] !== "-" &&
        element["operation"].toLowerCase().indexOf("io") > -1
      ) {
        total["iops"] += Number(element["total_storage"]);
      } else {
        total["storage"] += Number(element["total_storage"]);
      }
    });

    total["total"] = Number(total["total"]).toFixed(4);
    total["iops"] = Number(total["iops"]).toFixed(4);
    total["gb_cost"] = Number(total["gb_cost"]).toFixed(4);
    total["storage"] = Number(total["storage"]).toFixed(4);

    return total;
  }

  getTotalEBSFinal() {
    if (this.response["ebsTotalCost"] != this.response["ebsMrrTotalCost"]) {
      return `$<span class='line_through'>${this.response[
        "ebsTotalCost"
      ].toFixed(2)}</span> $${this.response["ebsMrrTotalCost"].toFixed(2)}`;
    } else {
      return "$" + this.response["ebsTotalCost"].toFixed(2);
    }
  }

  getTotalOthersFinal() {
    if (
      this.response["othersTotalCost"] != this.response["othersMrrTotalCost"]
    ) {
      return `$<span class='line_through'>${this.response[
        "othersTotalCost"
      ].toFixed(2)}</span> $${this.response["othersMrrTotalCost"].toFixed(2)}`;
    } else {
      return "$" + this.response["othersTotalCost"].toFixed(2);
    }
  }

  getTotalEC2(data: any) {
    let total: any = {
      finalTotal: 0,
      total: 0,
    };

    data.forEach((value: any) => {
      if (value["isMrr"] == "yes") {
        if (
          value["billingType"].toLowerCase() == "od" ||
          value["billingType"].toLowerCase() == "spot"
        ) {
          if (Number(value["total_cost"]) !== Number(value["mrrCost"])) {
            total["finalTotal"] += Number(value["mrrCost"]);
            total["total"] += Number(value["total_cost"]);
          } else {
            total["finalTotal"] += Number(value["total_cost"]);
          }
        } else {
          if (Number(value["riTotalCost"]) !== Number(value["mrrCost"])) {
            total["finalTotal"] += Number(value["mrrCost"]);
            total["total"] += Number(value["riTotalCost"]);
          } else {
            total["finalTotal"] += Number(value["riTotalCost"]);
          }
        }
      } else {
        if (
          value["billingType"].toLowerCase() == "od" ||
          value["billingType"].toLowerCase() == "spot"
        ) {
          total["finalTotal"] += Number(value["total_cost"]);
        } else {
          total["finalTotal"] += Number(value["riTotalCost"]);
        }
      }
    });

    if (total["total"] <= 0) {
      total["total"] = total["finalTotal"];
    }

    if (total["total"] != total["finalTotal"]) {
      return `<span class='line_through'>
        ${Number(total["total"]).toFixed(4)}
        </span>
        <span>
        ${Number(total["finalTotal"]).toFixed(4)}
        </span>`;
    } else {
      return `<span>${Number(total["total"]).toFixed(4)}</span>`;
    }
  }

  masterID: any;

  async loadEC2Data(show: boolean = false) {
    if (!show) {
      if (this.ec2Show) {
        this.ec2Show = false;
        this.nextTokens["ec2"] = null;
        return;
      }
      if (this.page_destroyed && !this.ec2Show) {
        this.nextTokens["ec2"] = null;
        return;
      }
    }
    if (!this.nextTokens["ec2"]) {
      this.mapMigratedEC2 = false;
      this.projectTagNameEC2 = false;
      this.ec2Data = [];
    }
    if (this.page_destroyed) {
      return;
    }
    this.ec2Show = true;
    this.notifier.loading(true);
    let data: any = {
      month_year: this.monthYear,
      lid: this.activeAccount.lid,
      userType: this.customerType || "C",
      masterAccId:
        this.customerType !== "mp" ? this.activeAccount.mid : undefined,
      more_instances: this.nextTokens["ec2"]
        ? this.nextTokens["ec2"]
        : undefined,
    };

    this.masterID =
      this.customerType !== "mp" ? this.activeAccount.mid : undefined;

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/ec2breakup`;

    if (this.customerType == "mp") {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    }

    if (environment.envName == "Development" && this.urlPrefix == "admin") {
      apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (result.items && Array.isArray(result.items)) {
      this.ec2Data = [...this.ec2Data, ...result.items];

      // Reset visible data when loading new data
      this.visibleData = {
        Spot: [],
        Usage: [],
        SavingsPlanCoveredUsage: [],
      };

      // Pre-populate initial data for each category
      const spotData = this.ec2Data.filter((item: any) => !item.breakUpType);
      const usageData = this.ec2Data.filter(
        (item: any) => item.breakUpType === "Usage"
      );
      const savingsData = this.ec2Data.filter(
        (item: any) => item.breakUpType === "SavingsPlanCoveredUsage"
      );

      if (spotData.length > 0) {
        this.visibleData["Spot"] = spotData.slice(0, this.PAGE_SIZE);
      }
      if (usageData.length > 0) {
        this.visibleData["Usage"] = usageData.slice(0, this.PAGE_SIZE);
      }
      if (savingsData.length > 0) {
        this.visibleData["SavingsPlanCoveredUsage"] = savingsData.slice(
          0,
          this.PAGE_SIZE
        );
      }

      // ... rest of existing code ...
    } else {
      this.notifier.alert("Info", "", result.msg, "info", 5000);
    }

    if (result.more_instances) {
      this.nextTokens["ec2"] = result.more_instances;
    } else {
      this.nextTokens["ec2"] = null;
    }

    this.notifier.loading(false);
  }

  exportData: any = [];

  // async exportEC2(lastEvalutedKey: any = null) {
  //   this.notifier.loading(true);
  //   if (!lastEvalutedKey) {
  //     this.exportData = [];
  //   }
  //   let data: any = {
  //     month_year: this.monthYear,
  //     lid: this.activeAccount.lid,
  //     userType: "C",
  //     masterAccId:
  //       this.customerType != "type" ? this.activeAccount.mid : undefined,
  //     more_instances: lastEvalutedKey ? lastEvalutedKey : undefined,
  //   };

  //   let header = {
  //     Authorization: localStorage.getItem("t"),
  //   };
  //   let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/ec2breakup`;

  //   if (this.customerType == "mp") {
  //     apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
  //   }

  //   if (environment.envName == "Development" && this.urlPrefix == "admin") {
  //     apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;
  //   }

  //   let result = await this.apiServer.postDataPromis(apiURL, data, header);

  //   if (result.status == "1" || result.s == "1") {
  //     this.exportData = [...this.exportData, ...result.items];
  //   } else {
  //     this.notifier.alert("Info", "", result.msg, "info", 5000);
  //   }

  //   if (result.more_instances) {
  //     await this.exportEC2(result.more_instances);
  //   } else {
  //     this.downloadEC2();
  //   }

  //   this.notifier.loading(false);
  // }

  // downloadEC2() {
  //   for (let index = 0; index < this.exportData.length; index++) {
  //     let ec2 = this.exportData[index];
  //     if (ec2.projectTagNameEC2 && !this.projectTagNameEC2) {
  //       this.projectTagNameEC2 = true;
  //     }
  //     if (ec2.mapMigrated && !this.mapMigratedEC2) {
  //       this.mapMigratedEC2 = true;
  //     }
  //     if (this.projectTagNameEC2 && this.mapMigratedEC2) {
  //       break;
  //     }
  //   }
  //   let total: any = {
  //     riTotalCost: 0,
  //     total_hours: 0,
  //   };
  //   let element = document.createElement("table");
  //   element.innerHTML += `
  //       <thead>
  //         <tr>
  //           <td>
  //             Month Year: ${this.monthYear}
  //           </td>
  //           <td>
  //             Account ID: ${this.activeAccount.lid}
  //           </td>
  //         </tr>
  //         <tr>
  //           <th>Sl. No.</th>
  //           ${this.ec2Headers.map((h: any) => {
  //             if (h.export) {
  //               if (h.displayConditional) {
  //                 if (!(h.displayConditional && this.getValue(h.id))) {
  //                   return "";
  //                 } else {
  //                   return `<th>${h.name}</th>`;
  //                 }
  //               } else {
  //                 return `<th>${h.name}</th>`;
  //               }
  //             } else {
  //               return "";
  //             }
  //           })}
  //         </tr>
  //       </thead>
  //       <tbody>
  //           ${this.exportData.map((ec2: any, index: any) => {
  //             return `
  //               <tr>
  //                 <td>${index + 1}</td>
  //                 ${this.ec2Headers.map((h: any) => {
  //                   if (h.export) {
  //                     if (h.displayConditional) {
  //                       if (!(h.displayConditional && this.getValue(h.id))) {
  //                         return "";
  //                       }
  //                     }
  //                   } else {
  //                     return "";
  //                   }
  //                   if (
  //                     (h.id == "riTotalCost" || h.id == "total_hours") &&
  //                     h.export
  //                   ) {
  //                     let value = h.alter ? h.alter(ec2, h.id) : ec2[h.id];
  //                     value = parseFloat(value);
  //                     total[h.id] += value;
  //                   }
  //                   return h.export
  //                     ? `
  //                     <td>
  //                       <span>${
  //                         ((h.alter ? h.alter(ec2, h.id) : ec2[h.id]) != "0" &&
  //                           (h.alter ? h.alter(ec2, h.id) : ec2[h.id])) != 0
  //                           ? h.alter
  //                             ? h.alter(ec2, h.id)
  //                             : ec2[h.id] != undefined && ec2[h.id] != null
  //                             ? ec2[h.id]
  //                             : ""
  //                           : "-"
  //                       }</span>
  //                     </td>
  //                   `
  //                     : "";
  //                 })}
  //               </tr>
  //             `;
  //           })}
  //           <tr>
  //               ${this.ec2Headers.map((h: any, index: any) => {
  //                 if (
  //                   index + 1 < this.ec2Headers.length &&
  //                   this.ec2Headers[index + 1].id == "total_hours"
  //                 ) {
  //                   return "<td>SUB TOTAL</td>";
  //                 }
  //                 if (
  //                   (h.id == "riTotalCost" || h.id == "total_hours") &&
  //                   h.export
  //                 ) {
  //                   return h.export
  //                     ? `
  //                     <td>
  //                       <span>${total[h.id]}</span>
  //                     </td>
  //                   `
  //                     : "";
  //                 }
  //                 return "<td></td>";
  //               })}
  //           </tr>
  //       </tbody>
  //     `;
  //   window.exportToExcelElement(
  //     element,
  //     `${this.activeAccount.lid}_${this.monthYear}`,
  //     "csv"
  //   );
  //   this.exportData = [];
  // }

  async loadEBSData(show: boolean = false) {
    if (!show) {
      if (this.ebsShow) {
        this.ebsShow = false;
        this.nextTokens["ebs"] = null;
        return;
      }
      if (this.page_destroyed && !this.ebsShow) {
        this.nextTokens["ebs"] = null;
        return;
      }
    }
    if (!this.nextTokens["ebs"]) {
      this.ebsData = [];
      this.IOPSshow = false;
      this.operationsChange = false;
      this.mapMigratedEBS = false;
      this.projectTagNameEBS = false;
    }
    if (this.page_destroyed) {
      return;
    }
    this.ebsShow = true;
    this.notifier.loading(true);
    let data: any = {
      month_year: this.monthYear,
      lid: this.activeAccount.lid,
      masterAccId:
        this.customerType !== "mp" ? this.activeAccount.mid : undefined,
      userType: this.customerType || "C",
      more_volumes: this.nextTokens["ebs"] ? this.nextTokens["ebs"] : undefined,
    };

    if (this.diff_days > 0) {
      data = {
        action: "fetchVolumes",
        month_year: this.monthYear,
        lid: this.activeAccount.lid,
        userType: this.customerType || "C",
        masterAccId:
          this.customerType !== "mp" ? this.activeAccount.mid : undefined,
        more_instances: this.nextTokens["ebs"]
          ? this.nextTokens["ebs"]
          : undefined,
      };
    }

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/${
      this.diff_days > 0 ? "ec2breakup" : "volumedetails"
    }`;

    if (this.customerType == "mp") {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    }

    if (environment.envName == "Development" && this.urlPrefix == "admin") {
      apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (
      (result.Items && result.Items.length > 0) ||
      (result.volumesList && result.volumesList.length > 0)
    ) {
      if (this.diff_days > 0) {
        this.ebsData = [...this.ebsData, ...result.volumesList];
      } else {
        this.ebsData = [...this.ebsData, ...result.Items];
      }
      this.ebsData = this.ebsData.map((ebs: any) => {
        ebs.projectTagNameEBS = ebs.projectTagName;
        delete ebs.projectTagName;
        ebs.mapMigratedEBS = ebs.mapMigrated;
        delete ebs.mapMigrated;
        if (ebs.operation && ebs.operation.trim() !== "-") {
          this.IOPSshow = true;
        }

        if (ebs.lid_volumeId && ebs.lid_volumeId.includes("_")) {
          ebs["volumeOperation"] = ebs["lid_volumeId"].split("_")[1];
          ebs["lid_volumeId"] = ebs["lid_volumeId"].split("_")[0];
          this.operationsChange = true;
        }
        return ebs;
      });

      for (let index = 0; index < this.ebsData.length; index++) {
        let ec2 = this.ebsData[index];
        // ec2.projectTagNameEBS = `Project Tag Name ${index}`;
        // ec2.mapMigratedEBS = `Map Migrate Tag Name ${index}`;
        if (ec2.projectTagNameEBS && !this.projectTagNameEBS) {
          this.projectTagNameEBS = true;
        }
        if (ec2.mapMigratedEBS && !this.mapMigratedEBS) {
          this.mapMigratedEBS = true;
        }
        if (this.projectTagNameEBS && this.mapMigratedEBS) {
          break;
        }
      }
    } else {
      this.notifier.alert("Info", "", result.msg, "info", 5000);
    }

    if (result.more_instances || result.more_volumes) {
      this.nextTokens["ebs"] = result.more_instances || result.more_volumes;
    } else {
      this.nextTokens["ebs"] = null;
    }

    this.notifier.loading(false);
  }

  getABS(value: number) {
    return Math.abs(value);
  }

  async exportEBS(nextToken: any = null) {
    this.notifier.loading(true);
    if (!nextToken) {
      this.exportData = [];
    }
    let data: any = {
      month_year: this.monthYear,
      lid: this.activeAccount.lid,
      masterAccId:
        this.customerType !== "mp" ? this.activeAccount.mid : undefined,
      userType: this.customerType || "C",
      more_instances: nextToken ? nextToken : undefined,
    };

    if (this.diff_days > 0) {
      data = {
        month_year: this.monthYear,
        lid: this.activeAccount.lid,
        userType: "C",
        masterAccId:
          this.customerType !== "mp" ? this.activeAccount.mid : undefined,
        more_instances: nextToken ? nextToken : undefined,
        action: "fetchVolumes",
      };
    }

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/${
      this.diff_days > 0 ? "ec2breakup" : "volumedetails"
    }`;

    if (this.customerType == "mp") {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (result.status == "1" || result.s == "1" || result.Items.length > 0) {
      let dt: any = result.Items || result.volumesList;
      dt = dt.map((ebs: any) => {
        ebs.projectTagNameEBS = ebs.projectTagName;
        delete ebs.projectTagName;
        ebs.mapMigratedEBS = ebs.mapMigrated;
        delete ebs.mapMigrated;
        if (ebs.lid_volumeId && ebs.lid_volumeId.includes("_")) {
          ebs["volumeOperation"] = ebs["lid_volumeId"].split("_")[1];
          ebs["lid_volumeId"] = ebs["lid_volumeId"].split("_")[0];
        }
        return ebs;
      });
      this.exportData = [...this.exportData, ...dt];
    } else {
      this.notifier.alert("Info", "", result.msg, "info", 5000);
    }
    if (result.more_instances) {
      await this.exportEBS(result.more_instances);
    } else {
      this.downloadEBS();
    }
    this.notifier.loading(false);
  }

  async loadOthersData(show: boolean = false) {
    if (!show) {
      if (this.othersShow) {
        this.othersShow = false;
        this.nextTokens["others"] = null;
        return;
      }
      if (this.page_destroyed && !this.othersShow) {
        this.nextTokens["others"] = null;
        return;
      }
    }
    if (!this.nextTokens["others"]) {
      this.othersData = [];
    }
    if (this.page_destroyed) {
      return;
    }
    this.othersShow = true;
    this.notifier.loading(true);
    let data = {
      month_year: this.monthYear,
      lid: this.activeAccount.lid,
      masterAccId:
        this.customerType !== "mp" ? this.activeAccount.mid : undefined,
      action: this.diff_days > 0 ? "fetchOtherDetails" : undefined,
      more_instances: this.nextTokens["others"]
        ? this.nextTokens["others"]
        : undefined,
      userType: this.customerType || "C",
    };

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/${
      this.diff_days > 0 ? "ec2breakup" : "updatedusagedetails"
    }`;

    if (this.customerType == "mp") {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    }

    if (environment.envName == "Development" && this.urlPrefix == "admin") {
      apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (
      (result.items && result.items.length > 0) ||
      (result.othersDataList && result.othersDataList.length > 0)
    ) {
      if (this.diff_days > 0) {
        this.othersData = [...this.othersData, ...result.othersDataList];
      } else {
        this.othersData = [...this.othersData, ...result.items];
      }
    } else {
      this.notifier.alert("Info", "", result.msg, "info", 5000);
    }

    if (result.more_instances) {
      this.nextTokens["others"] = result.more_instances;
    } else {
      this.nextTokens["others"] = null;
    }
    this.notifier.loading(false);
  }

  downloadEBS() {
    let total: any = {
      gb_cost: 0,
      total_storage: 0,
      total_cost: 0,
      total_iops: 0,
    };
    for (let index = 0; index < this.exportData.length; index++) {
      let ec2 = this.exportData[index];
      if (ec2.projectTagNameEBS && !this.projectTagNameEBS) {
        this.projectTagNameEBS = true;
      }
      if (ec2.mapMigratedEBS && !this.mapMigratedEBS) {
        this.mapMigratedEBS = true;
      }
      if (this.projectTagNameEBS && this.mapMigratedEBS) {
        break;
      }
    }
    let element = document.createElement("table");
    element.innerHTML += `
        <thead>
          <tr>
            <td>
              Month Year: ${this.monthYear}
            </td>
            <td>
              Account ID: ${this.activeAccount.lid}
            </td>
          </tr>
          <tr>
            <th>Sl. No.</th>
            ${this.ebsHeaders.map((h: any) => {
              if (h.export && (h.show === undefined || h.show() == true)) {
                if (h.displayConditional) {
                  if (!(h.displayConditional && this.getValue(h.id))) {
                    return "";
                  } else {
                    return `<th>${h.name}</th>`;
                  }
                } else {
                  return `<th>${h.name}</th>`;
                }
              } else {
                return "";
              }
            })}
          </tr>
        </thead>
        <tbody>
            ${this.exportData.map((ec2: any, index: any) => {
              return `
                <tr>
                  <td>${index + 1}</td>
                  ${this.ebsHeaders.map((h: any) => {
                    if (
                      h.export &&
                      (h.show === undefined || h.show() == true)
                    ) {
                      if (h.displayConditional) {
                        if (!(h.displayConditional && this.getValue(h.id))) {
                          return "";
                        }
                      }
                    } else {
                      return "";
                    }
                    if (
                      (h.id == "total_cost" ||
                        h.id == "total_storage" ||
                        h.id == "gb_cost") &&
                      h.export &&
                      (h.show === undefined || h.show() == true)
                    ) {
                      let value = h.alter ? h.alter(ec2[h.id], ec2) : ec2[h.id];
                      if (value == "-") {
                        value = 0;
                      }
                      value = parseFloat(value);
                      if (h.show && h.show()) {
                        total["total_iops"] += value;
                      } else {
                        total[h.id] += value;
                      }
                    }
                    return h.export &&
                      (h.show === undefined || h.show() == true)
                      ? `
                      <td>
                        <span>${
                          ((h.alter ? h.alter(ec2[h.id], ec2) : ec2[h.id]) !=
                            "0" &&
                            (h.alter ? h.alter(ec2[h.id], ec2) : ec2[h.id])) !=
                          0
                            ? h.alter
                              ? h.alter(ec2[h.id], ec2)
                              : ec2[h.id] != undefined && ec2[h.id] != null
                              ? ec2[h.id]
                              : ""
                            : "-"
                        }</span>
                      </td>
                    `
                      : "";
                  })}
                </tr>
              `;
            })}
            <tr>
                <td></td>
                <td></td>
                <td></td>
                ${this.operationsChange ? "<td></td>" : ""}
                <td>SUB TOTAL</td>
                ${this.ebsHeaders.map((h: any, index: any) => {
                  if (
                    (h.id == "total_cost" ||
                      h.id == "total_storage" ||
                      h.id == "gb_cost") &&
                    h.export
                  ) {
                    return h.export &&
                      (h.show === undefined || h.show() == true)
                      ? `
                      <td>
                        <span>${
                          h.show && h.show() ? total["total_iops"] : total[h.id]
                        }</span>
                      </td>
                    `
                      : "";
                  }
                  return "";
                  // return '<td></td>';
                })}
            </tr>
        </tbody>
      `;
    window.exportToExcelElement(
      element,
      `${this.activeAccount.lid}_${this.monthYear}`,
      "csv"
    );
    this.exportData = [];
  }

  async exportOthers() {
    this.notifier.loading(true);
    let total: any = {
      cost: 0,
    };

    let data: any = {
      month_year: this.monthYear,
      lid: this.activeAccount.lid,
      masterAccId:
        this.customerType !== "mp" ? this.activeAccount.mid : undefined,
      more_instances: this.nextTokens["others"]
        ? this.nextTokens["others"]
        : undefined,
      action: "fetchTotalOtherDetails",
    };

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/${
      this.diff_days > 0 ? "ec2breakup" : "updatedusagedetails"
    }`;

    if (this.customerType == "mp") {
      apiURL = `${APIService.API_ENDPOINTV3}/market/billing/subdetails`;
    }

    if (environment.envName == "Development" && this.urlPrefix == "admin") {
      apiURL = `${environment.apiURL}/${this.urlPrefix}/billing/ec2breakup`;
    }

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if (
      result.status == "1" ||
      result.s == "1" ||
      result.Items?.length > 0 ||
      result.othersDataList?.length > 0
    ) {
      let dt: any = result.Items || result.othersDataList;
      let element = document.createElement("table");
      let index = 0;

      element.innerHTML += `
      <thead>
        <tr>
          <td>Month Year: ${this.monthYear}</td>
          <td>Account ID: ${this.activeAccount.lid}</td>
        </tr>
        <tr>
          <th>Sl. No.</th>
          ${this.othersHeaders
            .map((h: any) => (h.export ? `<th>${h.name}</th>` : ""))
            .join("")}
        </tr>
      </thead>
      <tbody>
        ${dt
          .map((ec2: any) => {
            if (ec2["total_cost"] == "0" || ec2["total_cost"] == 0) {
              return "";
            }
            index += 1;

            return `
              <tr>
                <td>${index}</td>
                ${this.othersHeaders
                  .map((h: any) => {
                    let cellValue: any = ec2[h.id];

                    if (h.id === "mrrCost") {
                      cellValue =
                        ec2["isMrr"] === "yes"
                          ? ec2["mrrCost"]
                          : ec2["total_cost"];

                      total.cost += parseFloat(cellValue || 0);
                    }

                    if (
                      !isNaN(cellValue) &&
                      cellValue !== "" &&
                      h.id !== "lid_resourceId" &&
                      h.id !== "resource_name" &&
                      h.id !== "isMrr"
                    ) {
                      cellValue = Number(cellValue).toFixed(4);
                    }

                    return h.export
                      ? `<td><span>${
                          cellValue && cellValue != "0" ? cellValue : "-"
                        }</span></td>`
                      : "";
                  })
                  .join("")}
              </tr>`;
          })
          .join("")}
        <tr>
          <td></td>
          ${this.othersHeaders
            .map((h: any, idx: any) => {
              if (h.id === "mrrCost" && h.export) {
                return `<td><span>${total.cost.toFixed(4)}</span></td>`;
              }
              if (
                idx + 1 < this.othersHeaders.length &&
                this.othersHeaders[idx + 1].id === "mrrCost"
              ) {
                return "<td>SUB TOTAL</td>";
              }
              return "<td></td>";
            })
            .join("")}
        </tr>
      </tbody>
    `;

      window.exportToExcelElement(
        element,
        `${this.activeAccount.lid}_${this.monthYear}`,
        "csv"
      );
    } else {
      this.notifier.alert("Info", "", result.msg, "info", 5000);
    }

    this.notifier.loading(false);
  }

  export(table_name: any, file_name: any) {
    if (this.diff_days > 0) {
      this.showConditionalElement = true;
    }

    setTimeout(() => {
      window.exportToExcel(
        table_name,
        file_name + `_${this.activeAccount.lid}`,
        "csv"
      );
      setTimeout(() => {
        this.showConditionalElement = false;
      }, 100);
    }, 100);
  }

  ngOnDestroy(): void {
    this.page_destroyed = true;
  }

  getEC2SubcategoryData(type: SubcategoryKey): any[] {
    // Always return visible data, regardless of expanded state
    if (type === "Spot") {
      if (this.visibleData[type].length === 0) {
        this.visibleData[type] = this.ec2Data
          .filter((item: any) => !item.breakUpType)
          .slice(0, this.PAGE_SIZE);
      }
    } else {
      if (this.visibleData[type].length === 0) {
        this.visibleData[type] = this.ec2Data
          .filter((item: any) => item.breakUpType === type)
          .slice(0, this.PAGE_SIZE);
      }
    }
    return this.visibleData[type];
  }

  onScroll(event: any, type: SubcategoryKey) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop - element.clientHeight < 50) {
      const currentLength = this.visibleData[type].length;
      const filteredData =
        type === "Spot"
          ? this.ec2Data.filter((item: any) => !item.breakUpType)
          : this.ec2Data.filter((item: any) => item.breakUpType === type);

      if (currentLength < filteredData.length) {
        this.visibleData[type] = [
          ...this.visibleData[type],
          ...filteredData.slice(currentLength, currentLength + this.PAGE_SIZE),
        ];
      }
    }
  }

  // Add this new method to handle expansion/collapse
  toggleExpanded(type: SubcategoryKey) {
    this.expanded[type] = !this.expanded[type];

    // Reset visible data when collapsing
    if (!this.expanded[type]) {
      this.visibleData[type] = [];
    } else {
      // Load initial data when expanding
      if (type === "Spot") {
        this.visibleData[type] = this.ec2Data
          .filter((item: any) => !item.breakUpType)
          .slice(0, this.PAGE_SIZE);
      } else {
        this.visibleData[type] = this.ec2Data
          .filter((item: any) => item.breakUpType === type)
          .slice(0, this.PAGE_SIZE);
      }
    }
  }
}
